import { Button, Grid, makeStyles } from '@material-ui/core'

const useStyles = makeStyles((theme) => ({
  buttonsContainer: {
    marginTop: theme.spacing(3),
    marginBottom: theme.spacing(2)
  },
  saveButton: {
    color: 'secondary',
    justifySelf: 'end'
  },
  marginButton: {
    marginLeft: theme.spacing(1)
  }
}))

const SaveOrCancelButtons = (props) => {
  const classes = useStyles()
  const onSave = props.onSave
  const onCancel = props.onCancel
  const loading = props.loading
  const saveLabel = props.saveLabel ? props.saveLabel : 'Guardar'
  const cancelLabel = props.cancelLabel ? props.cancelLabel : 'Cancelar'
  const otherOptions = props.otherOptions ? props.otherOptions : []
  return (
    <Grid item xs={12}>
      <Grid container direction="row" justify="flex-end" className={classes.buttonsContainer}>
        {otherOptions.map((option, index) => {
          return <div key={`save-or-cancel-button-option-${index}`}>{option}</div>
        })}

        {onSave ? (
          <Button
            disabled={loading}
            variant="contained"
            className={classes.marginButton}
            color="secondary"
            onClick={onSave}
          >
            {saveLabel}
          </Button>
        ) : (
          ''
        )}

        {onCancel ? (
          <Button
            disabled={loading}
            variant="contained"
            className={`${classes.saveButton} ${classes.marginButton}`}
            onClick={onCancel}
          >
            {cancelLabel}
          </Button>
        ) : (
          ''
        )}
      </Grid>
    </Grid>
  )
}

export default SaveOrCancelButtons
